import React from "react";
import CardWithButton from "../CommonComponents/CardWithButton";
import { downloadClick } from "../CommonFunctions/Function";
import { eventTracker } from "../GATracker3.0/eventTracker";
import { DOWNLOAD_APP_CLICKED } from "../GATracker3.0/constants";
import { useLocation } from "react-router";

const HeaderDownload = (props) => {
  const location = useLocation();
  return (
    <>
      <CardWithButton
        title={`Download ${props.aryaShakti ? "AryaShakti" : "arya.ag"} App`}
        subtitle={
          props.text ? props.text : "arya.ag App Available in Your Language!"
        }
        buttonText="Download"
        radius={props.radius}
        onClick={() => {
          if (!props.aryaShakti) {
            eventTracker("event", DOWNLOAD_APP_CLICKED, {
              pagename:
                location.pathname === "/" ? "homepage" : location.pathname,
            });
          }
          downloadClick(props.aryaShakti ? "arya-shakti" : "");
        }}
      />
    </>
  );
};
export default HeaderDownload;
